







































import { defineComponent } from '@vue/composition-api'
import VideoPlayer from '@/components/VideoPlayer'
import VuMeter from '@/modules/streams/components/VuMeter'
import fb from '../../firebase'
import './FinalOutputPlayer.scss'
import { CastStream, StreamDoc } from '@/types/streams'
import { CollectionNames } from '@/modules/database/utils'
import VideoLoadingOverlay from '@/modules/video/components/VideoLoadingOverlay'
import { VuMeterStreamInfo } from '@/modules/streams/components/VuMeter'
import store from '@/store'
import { Cast } from '@/modules/casts/classes'
import { useTeamBranding } from '@/modules/teams/compositions'
import { CastType } from '@/types/casts'
import { computed, toRef } from '@vue/composition-api'

type UnsubscribeFunction = () => void

export default defineComponent({
  name: 'FinalOutputPlayer',
  props: {
    mute: {
      type: Boolean,
      default: true
    },
    showIfBooting: {
      type: Boolean,
      required: false,
      default: true
    },
    showMaximize: {
      type: Boolean,
      default: true
    },
    showMuteBtn: {
      type: Boolean,
      default: true
    },
    cast: {
      type: Object as () => Cast,
      required: true
    },
    videoToLoad: {
      type: String,
      required: true
    },
    audioActivated: {
      type: Boolean,
      required: false
    },
    isJanus: {
      type: Boolean,
      required: false,
      default: false
    },
    streamUrl: {
      type: String,
      required: false
    }
  },
  data: () => ({
    streamDoc: {} as StreamDoc,
    variantToLoad: '',
    refId: null,
    subscribeFunction: null as null|UnsubscribeFunction
  }),
  created () {
    this.loadStreamDoc()
  },
  destroyed () {
    this.unloadStreamDoc()
  },
  setup (props) {
    const cast = toRef(props, 'cast')
    const branding = useTeamBranding().branding
    const placeholderUrl = computed(() => branding.value.placeholderImageUrl)
    const isPlaceholderEnabled = computed(() => cast.value.castType === CastType.FanRoom)

    return {
      isPlaceholderEnabled,
      placeholderUrl
    }
  },
  computed: {
    previewUrl (): string {
      const route = this.$router.resolve({ name: 'preview', params: { castId: this.cast.id } })
      return route.href
    },
    videoReady (): boolean {
      return !!(this.videoSource?.srcObject)
    },
    streams (): VuMeterStreamInfo[] {
      return [{
        streamId: this.videoToLoad,
        channel: 0,
        volume: 100
      },
      {
        streamId: this.videoToLoad,
        channel: 1,
        volume: 100
      }]
    },
    videoSource (): CastStream|null {
      return store.state.streams.castStreams[this.videoToLoad] ?? null
    }
  },
  watch: {
    videoToLoad () {
      this.loadStreamDoc()
    }
  },
  methods: {
    unloadStreamDoc () {
      if (this.subscribeFunction !== null) {
        this.subscribeFunction()
        this.subscribeFunction = null
      }
    },
    loadStreamDoc () {
      if (this.isPlaceholderEnabled) return
      this.unloadStreamDoc()
      if (this.videoToLoad !== '') {
        this.subscribeFunction = fb.db.collection(CollectionNames.STREAMS).doc(this.videoToLoad).onSnapshot(snap => {
          if (snap.exists === true) {
            this.streamDoc = snap.data() as StreamDoc
            if (!this.isJanus && this.streamDoc.hasOwnProperty('variants')) {
              if (this.streamDoc.variants.hasOwnProperty('original')) {
                this.$emit('addOutputVideo', { video: this.videoToLoad, variant: this.streamDoc.variants.original })
              }
            }
            else if (this.isJanus) {
              const variant  = {
                    url: this.streamUrl ? this.streamUrl : this.streamDoc.srcurl.replace('whip', 'whep'),
                    hasaudio: true,
                    hasvideo: true,
                    mongoid: '',
                    pubtime: 0,
                    server: ''
              }
              this.$emit('addOutputVideo', { video: this.videoToLoad, variant: variant })
            }
          } else {
            console.log('no stream doc found for ', this.videoToLoad)
          }
        }, error => {
          console.error('error loadStreamDoc ' + this.videoToLoad + ' ' + error)
        })
      }
    },
    toggleMute () {
      this.$emit('toggleMute')
    },
    videoClicked () {
      this.$emit('videoClicked')
    }
  },
  components: {
    VideoPlayer,
    VuMeter,
    VideoLoadingOverlay
  }
})
